import React from 'react'
import { connect } from 'react-redux'
import {Card, CardActions, CardHeader, CardMedia, CardTitle, CardText} from 'material-ui/Card';
import FlatButton from 'material-ui/FlatButton'
import IconButton from 'material-ui/IconButton';
import MenuItem from 'material-ui/MenuItem';
import IconMenu from 'material-ui/IconMenu';
import Subheader from 'material-ui/Subheader';
import StarBorder from 'material-ui/svg-icons/toggle/star-border';
import AppBar from 'material-ui/AppBar';
import {Helmet} from "react-helmet";

import './styles.css'
import { getPlaceDataById } from '../Place/actions'
import { getNewsDataById } from '../News/actions'
import { getHotelsDataById } from '../Hotels/actions'
import { getFoodDataById } from '../Food/actions'
import { getOtopDataById } from '../Otop/actions'
import { getShoppingDataById } from '../Shopping/actions'
import {
  addBookmark,
  deleteBookmark
} from '../Bookmark/actions'

import lineIcon from './line.png'
import facebookIcon from './facebook.png'
import twitterIcon from './twitter.png'
import googlePlusIcon from './googlePlus.png'

import language from '../../config/language'

const Menu = (props) => (
  <IconMenu
    {...props}
    iconButtonElement={
      <IconButton>
      <i className="material-icons iconWhite">favorite_border</i>
      </IconButton>
    }
    targetOrigin={{horizontal: 'right', vertical: 'top'}}
    anchorOrigin={{horizontal: 'right', vertical: 'top'}}
  >
    <MenuItem primaryText="Add to bookmark" />
  </IconMenu>
)

class Details extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      type: 'place',
      strick: false
    } 
    this.handleScroll = this.handleScroll.bind(this)
  }
  componentDidMount() {
    const { match } = this.props
    const { types, id } = match.params
    if (types === 'popularPlace') {
      this.props.getPlaceDataById(id)
      this.setState({ type: 'place' })
    }
    if (types === 'popularFood') {
      this.props.getFoodDataById(id)
      this.setState({ type: 'food' })
    }
    if (types === 'popularOtop') {
      this.props.getOtopDataById(id)
      this.setState({ type: 'otop' })
    }
    if (types === 'popularHotels') {
      this.props.getHotelsDataById(id)
      this.setState({ type: 'hotels' })
    }
    if (types === 'popularNews') {
      this.props.getNewsDataById(id)
      this.setState({ type: 'news' })
    }
    if (types === 'popularShopping') {
      this.props.getShoppingDataById(id)
      this.setState({ type: 'shopping' })
    }
    window.addEventListener('scroll', this.handleScroll)
  }
  componentWillUnmount() {
    window.removeEventListener('scroll', this.handleScroll)
  }
  handleScroll(event) {
    if (window.pageYOffset > 200 && !this.state.strick) { // 65
      this.setState({
        strick: true
      })
    } else if (window.pageYOffset < 200/2 && this.state.strick) { /// ===0
      this.setState({
        strick: false
      })
    }
  }
  isAddToBookmark() {
    const { match, bookmark = [] } = this.props
    const { types, id } = match.params
    return bookmark.some(value => value.contentId === id && value.contentType === types)
  }
  onHandleClickBookmark() {
    const { match, bookmark } = this.props
    const { types, id } = match.params
    const payload = {
      contentType: types,
      contentId: id
    }
    const { id: bookmarkId = '' } = bookmark.find(value => value.contentId === id && value.contentType === types) ||  { id: '' }
    return (
      this.isAddToBookmark()
      ? this.props.deleteBookmark(bookmarkId)
      : this.props.addBookmark(payload)
    )
  }
  render() {
    const {
      title,
      cover_photo,
      description,
      content,
      created,
      area_id,
      category_id,
      viewed: view = 0,
      //  for otop
      picture_url = '',
      address = '',
      tel = '',
      email = '',
      facebook_page_url = '',
      line_id = '',
      link
    } = this.props[this.state.type].data
    const haveData = Object.keys(this.props[this.state.type].data).length > 0
    const details = language[this.props.lang].details
    const { offlineMsg, incorrect } = language[this.props.lang].system
    const {
      areas,
      category,
      lang
    } = this.props
    const getArea = areas.find(value => value.id === area_id) || ''
    const getCategory = category.find(value => value.id === category_id) || ''
    // window.location
    // console.log('window.location', window.location.href)
    const url = link
    const viewed = parseInt(view)
    let renderStar = () => {
      if (viewed >= 10) {
        return  (
          <div>
            <StarBorder color="yellow" />
            <StarBorder color="yellow" />
            <StarBorder color="yellow" />
            <StarBorder color="yellow" />
            <StarBorder color="yellow" />
          </div>
        )
      } else if (viewed >= 8) {
        return  (
          <div>
            <StarBorder color="yellow" />
            <StarBorder color="yellow" />
            <StarBorder color="yellow" />
            <StarBorder color="yellow" />
            <StarBorder color="white" />
          </div>
        )
      } else if (viewed >= 6) {
        return  (
          <div>
            <StarBorder color="yellow" />
            <StarBorder color="yellow" />
            <StarBorder color="yellow" />
            <StarBorder color="white" />
            <StarBorder color="white" />
          </div>
        )
      } else if (viewed >= 4) {
        return  (
          <div>
            <StarBorder color="yellow" />
            <StarBorder color="yellow" />
            <StarBorder color="white" />
            <StarBorder color="white" />
            <StarBorder color="white" />
          </div>
        )
      } else if (viewed >= 1) {
        return  (
          <div>
            <StarBorder color="yellow" />
            <StarBorder color="white" />
            <StarBorder color="white" />
            <StarBorder color="white" />
            <StarBorder color="white" />
          </div>
        )
      } else {
        return  (
          <div>
            <StarBorder color="white" />
            <StarBorder color="white" />
            <StarBorder color="white" />
            <StarBorder color="white" />
            <StarBorder color="white" />
          </div>
        )
      }
    }
    return (
      <div className="detail">
        <AppBar
          title={!this.state.strick ? '' : title}
          iconElementLeft={
            <IconButton
              onClick={() => this.props.history.goBack()}
            >
              <i className="material-icons">arrow_back</i>
            </IconButton>
          }
          iconElementRight={
            this.state.type !== 'news'
            ?
            <IconButton
              onClick={() => this.onHandleClickBookmark()}
            >
              <i className="material-icons">{this.isAddToBookmark() ? 'favorite' : 'favorite_border'}</i>
            </IconButton>
            : <div />
          }
          style={{
            position: 'fixed',
            backgroundColor: !this.state.strick ? 'transparent' : '#75b41c',
            ...(!this.state.strick) ? { boxShadow: 'none' } : {}
          }}
        />
        <Card>
        <CardMedia
          style={{
            ...(!haveData) ? {
              minHeight: 250,
              backgroundColor: 'rgba(0, 0, 0, 0.54)'
            } : {},
            ...(!this.props.online && !title) ? {
              minHeight: 250,
              backgroundColor: 'rgba(0, 0, 0, 0.54)'
            } : {}
          }}
          overlay={
           <CardTitle
             // title={(!this.props.online && !title) ? offlineMsg : title}
             title={
              this.props.online ? title
              : (title || offlineMsg)
             }
             titleStyle={{
                display: '-webkit-box',
                WebkitLineClamp: 1,
                WebkitBoxOrient: 'vertical',
                overflow: 'hidden'
             }}
             // subtitle={created}
            >
            <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between' }}>
              <div>
                {/* <p style={{ color: '#ffffff' }}>{(!this.props.online && !haveData) ? incorrect : created}</p> */}
                <p style={{ color: '#ffffff' }}>
                  {
                    this.props.online ? created
                    : (created || incorrect)
                  }
                </p>
              </div>
              {
                (!this.props.online && !title)
                ? null
                : renderStar()
              }
            </div>
           </CardTitle>
          }
        >
          <img src={(cover_photo || picture_url).toString().replace('https:', '')} alt="" />
        </CardMedia>
        <CardTitle
          title={title}
          subtitle={
            <div style={{ marginTop: 10 }}>
              <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                <div>
                  <span>{details.date+': '}</span>
                  <span>{created}</span>
                </div>
                {/* {
                  category_id
                  ? 
                  <div>
                    <span>{details.category+': '}</span>
                    <span>{getCategory ? getCategory['title_'+lang] : ''}</span>
                  </div>
                : null
                } */}
              </div>
              {
                this.state.type === 'place' ?
                (area_id ?
                  <div style={{ marginTop: 5 }}>
                    <span>{details.area+': '}</span>
                    <span>{getArea ? getArea['title_'+lang] : ''}</span>
                  </div>
                : null)
                : (category_id ?
                  <div>
                    <span>{details.category+': '}</span>
                    <span>{getCategory ? getCategory['title_'+lang] : ''}</span>
                  </div>
                : null)
              }
            </div>
          }
        />
        <CardText>
        <div id="wrapperSocial">
            <a href={"http://www.facebook.com/sharer.php?u="+url}  target="_blank"  className='socialIcon facebook'>
              <img src={facebookIcon} />
            </a>
            <a href={"https://twitter.com/share?url="+url}  target="_blank" className='socialIcon twitter'>
              <img src={twitterIcon} />
            </a>
            <a  href={"https://plus.google.com/share?url="+url}  target="_blank" className='socialIcon googlePlus'>
              <img src={googlePlusIcon}  />
            </a>
            <a href={" https://timeline.line.me/social-plugin/share?url="+url}  target="_blank" className='socialIcon line'>
              <img src={lineIcon}  />
            </a>
          </div>  
          </CardText>    
        </Card>
        <Card>
          <CardText>
            <div id="wrapperContent">
              <p dangerouslySetInnerHTML={{__html: content}} />
              {(this.state.type === 'otop' && Object.keys(details).length > 0) && (
                <div>
                  <p style={{ textIndent: 0 }}>{description || '-'}</p>
                  <p style={{ textIndent: 0 }}><strong>{details.address}</strong> {address || '-'}</p>
                  <p style={{ textIndent: 0 }}><strong>{details.tel}</strong> {tel || '-'}</p>
                  <p style={{ textIndent: 0 }}><strong>{details.email}</strong> {email || '-'}</p>
                  <p style={{ textIndent: 0 }}><strong>{details.facebook}</strong> {facebook_page_url || '-'}</p>
                  <p style={{ textIndent: 0 }}><strong>{details.line}</strong> {line_id || '-'}</p>
                </div>
              )}
            </div>
          </CardText>
        </Card>
      </div>
    )
  }
}

const mapStateToProps = ({ lang, areas, category, online, bookmark, ...state }) => ({
  place: state.place.details[lang],
  food: state.food.details[lang],
  otop: state.otop.details[lang],
  hotels: state.hotels.details[lang],
  news: state.news.details[lang],
  shopping: state.shopping.details[lang],
  lang,
  areas,
  category,
  online,
  bookmark
})
export default connect(mapStateToProps, {
  getPlaceDataById,
  getNewsDataById,
  getHotelsDataById,
  getFoodDataById,
  getOtopDataById,
  getShoppingDataById,
  addBookmark,
  deleteBookmark
}
)(Details)



// WEBPACK FOOTER //
// ./src/containers/Details/Details.js